
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import FormModelDisplay from '@/components/FormModelDisplay.vue';
import DirectNavigationItemRepository from '@/repositories/directnavigation/DirectNavigationItemRepository';
import DirectNavigationItemTranslationRepository from '@/repositories/directnavigation/DirectNavigationItemTranslationRepository';
import EmbeddedForm from '@/util/form/EmbeddedForm';

@Component({
    components: {
        GeneralScaffold,
        FormModelDisplay,
    },
})
export default class DirectNavigationListScreen extends Vue {
    @Inject()
    private readonly directNavigationItemRepository!: DirectNavigationItemRepository;

    @Inject()
    private readonly directNavigationItemTranslationRepository!: DirectNavigationItemTranslationRepository;

    private get embeds(): EmbeddedForm[] {
        return [
            {
                relationship: 'translations',
                parentRefKey: 'directNavigationItemId',
                i18nGroup: 'directNavigationItemTranslation',
                entityRepository: this.directNavigationItemTranslationRepository,
                columns: ['lang', 'name'],
            },
            {
                relationship: 'order',
                parentRefKey: 'directNavigationItemId',
                i18nGroup: 'directNavigationItem',
                entityRepository: this.directNavigationItemRepository,
                columns: ['defaultName'],
            },
        ];
    }
}
